import { Base_Url } from '../../BaseUrl/BaseUrl';
import {
  getApiWithAuthorization,
  // getApiWithoutAuthorization,
  // deleteApiWithAuthorization,
  postApiWithAuthorization,
  patchApiWithAuthorization, // Imported patch method
  putApiWithoutAuthorization, 
} from '../../Services/ApiMethods/ApiMethods';

// ...

export const get_dashboard_stats = async () => {
  const res = await getApiWithAuthorization(`${Base_Url}/employer/dashboard`);
  return res;
};

export const get_employer_profile = async () => {
  const res = await getApiWithAuthorization(`${Base_Url}/employer/profile`);
  return res;
};

export const update_employer_profile = async (data) => {
  // Using true PATCH method
  const res = await patchApiWithAuthorization(`${Base_Url}/employer/profile`, data); 
  return res;
};

export const upload_employer_logo = async (data) => {
  const res = await postApiWithAuthorization(`${Base_Url}/employer/profile/logo`, data);
  return res;
};

export const upload_employer_header = async (data) => {
  const res = await postApiWithAuthorization(`${Base_Url}/employer/profile/header`, data);
  return res;
};

export const get_recent_jobs = async () => {
  const res = await getApiWithAuthorization(`${Base_Url}/employer/dashboard/recent-jobs`);
  return res;
};

export const get_notifications = async () => {
  const res = await getApiWithAuthorization(`${Base_Url}/employer/notifications`);
  return res;
};
